import React from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaRegUser } from "react-icons/fa";
import { MdLogout } from "react-icons/md";
import "./AppNavbar.css";
import { handleCheckUserLogin } from "../../MIS/Global";
const UserDropdown = ({ isLogin, setSmShow, handleLogOut, navigate }) => {
  const renderTooltip = (props, text) => (
    <Tooltip id="user-tooltip" {...props}>
      {text}
    </Tooltip>
  );
  
  const isLoginCheck=()=>{
    const isLogin = handleCheckUserLogin("userData", "id");
    return isLogin <= 0 ? "d-none" : '';
  }
  
  return (
    <>

      <Dropdown align="end">
        <Dropdown.Toggle
          as="div"
          style={{
            border: "none",
            backgroundColor: "transparent",
            cursor: "pointer",
          }}
        >
          {isLogin ? (
            <MdLogout style={{ fontSize: "18px", color: "#333" }} />
          ) : (
            <FaRegUser style={{ fontSize: "18px", color: "#333" }} />
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu className="custom-user-menu">
          {!isLogin ? (
            <Dropdown.Item
              onClick={() => setSmShow(true)}
              className="dropdown-login"
            >
              Login
            </Dropdown.Item>
          ) : (
            <Dropdown.Item
              onClick={handleLogOut}
              className="dropdown-logout"
            >
              Logout
            </Dropdown.Item>
          )}

          <Dropdown.Item
            onClick={() => navigate("/yours-order")}
            className={`dropdown-orders ${isLoginCheck()}`}
          >
            Your Orders
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    
    </>
  );
};

export default UserDropdown;
